import { X } from 'kzv-icons';
import React from 'react';
import { components } from 'react-select';

function ClearIndicator(props) {
    return (
        <components.ClearIndicator {...props} styles={{ paddingRight: 0 }}>
            <div style={{ padding: 0 }}>
                <X style={{ strokeWidth: 2, stroke: 'black' }} />
            </div>
        </components.ClearIndicator>
    );
}

export default ClearIndicator;
